import type { Societe } from '~/services/BusinessTraveller/BusinessTravellerService';

export function getSilverGrantProgress(settings: Societe | null | undefined, qualifiedOrders: number) {
  const silver = settings?.silver;
  if (!silver?.enabled || silver.threshold <= 0) return undefined;
  return {
    threshold: silver.threshold,
    qualifiedOrders,
    remaining: Math.max(0, silver.threshold - qualifiedOrders),
  };
}
